<template>
  <div class="color-input">
    <span v-if="label" class="color-input__label">{{ label }}</span>
    <input class="color-input__input" type="color" v-model="innerValue" />
  </div>
</template>

<script>
export default {
  name: "ColorInput",
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.color-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  border: 1px solid $secondary-300;
  border-radius: 4px;
  padding: 16px;

  &__label {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: $secondary-500;
  }
  &__input {
    background-color: $white;
    border-radius: 8px;
    height: 32px;
    width: 32px;
    flex: 0 0 32px;
    padding: 0;
    border: none;
    cursor: pointer;

    &::-webkit-color-swatch-wrapper {
      padding: 0;
    }
    &::-webkit-color-swatch {
      border: 0.5px solid $black;
      border-radius: 4px;
    }
  }
}
</style>
